import {Auditoria} from "../../bibliotecaPjus/models/comum.models";
import {IFormulario, IModel} from "../../bibliotecaPjus/models/contrato.models";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {Negociacao} from "./negociacao.model";
import {TipoArquivoPermitido} from "../enum/tipo-arquivo-permitido.enum";

export class Proposta extends Auditoria implements IModel, IFormulario {

  propostaId: string;
  nomeCliente: string;
  nomeUsuarioParceiro: string;
  numeroPrecatorio: string;
  numeroProcesso: string;
  motivoReprovacao: string;
  motivoReprovacaoDocumento: string;
  valorBruto: number;
  valorComissao: number;
  status: string;
  active: boolean;
  documentoCedente: string;
  base64Oficio: string;
  extensaoArquivoOficio: string;
  dataCriacao: string;
  ofertaGerada: number;
  valorCliente: number;
  cpf: string;
  negociacao: Negociacao;
  honorarios: number;
  observacao: string;
  destacado: boolean;
  tipoCompra: string;
  urlDocumentoProposta : string;
  dataVencimento : string;
  diasParaOVencimento: number;
  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.propostaId = other.propostaId;
      this.nomeCliente = other.nomeCliente;
      this.nomeUsuarioParceiro = other.nomeUsuarioParceiro;
      this.cpf = other.cpf;
      this.numeroPrecatorio = other.numeroPrecatorio;
      this.numeroProcesso = other.numeroProcesso;
      this.motivoReprovacao = other.motivoReprovacao;
      this.motivoReprovacaoDocumento = other.motivoReprovacaoDocumento;
      this.valorBruto = other.valorBruto;
      this.valorComissao = other.valorComissao;
      this.ofertaGerada = other.ofertaGerada;
      this.dataCriacao = other.dataCriacao;
      this.valorCliente = other.valorCliente;
      this.negociacao = new Negociacao(other.negociacao);
      this.status = other.status;
      this.active = other.active;
      this.honorarios = other.honorarios;
      this.observacao = other.observacao;
      this.destacado = other.destacado;
      this.tipoCompra = other.tipoCompra;
      this.diasParaOVencimento = other.diasParaOVencimento;
      this.urlDocumentoProposta = other.urlDocumentoProposta;
      this.dataVencimento = other.dataVencimento;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        propostaId: new FormControl(this.propostaId),
        documentoCedente: new FormControl(this.documentoCedente, [Validators.required, this.validarDocumento()]),
        numeroPrecatorio: new FormControl(this.numeroPrecatorio, [Validators.required]),
        base64Oficio: new FormControl(this.base64Oficio, [Validators.required]),
        extensaoArquivoOficio: new FormControl(this.extensaoArquivoOficio, [Validators.required, this.pdfFileValidator()]),
        observacao: new FormControl(this.observacao, [Validators.required]),
        destacado: new FormControl(this.destacado, [Validators.required]),
        tipoCompra: new FormControl(this.tipoCompra),
        honorarios: new FormControl(this.honorarios)
      });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }

  validarDocumento() {
    return (control: AbstractControl): Validators => {
      const cpf = control.value;
      if (cpf) {
        let numeros, digitos, soma, i, resutado, digitosIguais;
        digitosIguais = 1;
        if (cpf.length > 11) {
          if(this.isValidCnpj(cpf)) {
            return null;
          } else {
            return {documentoInvalido: true};
          }
        }

        for (i = 0; i < cpf.length - 1; i++) {
          if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
          }
        }

        if (!digitosIguais) {
          numeros = cpf.substring(0, 9);
          digitos = cpf.substring(9);
          soma = 0;
          for (i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
          }

          resutado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

          if (resutado !== Number(digitos.charAt(0))) {
            return {documentoInvalido: true};
          }
          numeros = cpf.substring(0, 10);
          soma = 0;

          for (i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
          }
          resutado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

          if (resutado !== Number(digitos.charAt(1))) {
            return {documentoInvalido: true};
          }
          return null;
        } else {
          return {documentoInvalido: true};
        }
      }
      return null;
    };
  }

  isValidCnpj(cnpj: string): boolean {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj.length !== 14) {
      return false;
    }

    if (/^(\d)\1+$/.test(cnpj)) {
      return false;
    }

    let soma = 0;
    let fator = 5;
    for (let i = 0; i < 12; i++) {
      soma += parseInt(cnpj.charAt(i)) * fator;
      fator = fator === 2 ? 9 : fator - 1;
    }

    let restante = soma % 11;
    let digito = restante < 2 ? 0 : 11 - restante;

    if (parseInt(cnpj.charAt(12)) !== digito) {
      return false;
    }

    soma = 0;
    fator = 6;
    for (let i = 0; i < 13; i++) {
      soma += parseInt(cnpj.charAt(i)) * fator;
      fator = fator === 2 ? 9 : fator - 1;
    }

    restante = soma % 11;
    digito = restante < 2 ? 0 : 11 - restante;

    if (parseInt(cnpj.charAt(13)) !== digito) {
      return false;
    }

    return true;
  }

  pdfFileValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const isPdf = control.value?.toLowerCase() === TipoArquivoPermitido.PDF;
      return isPdf ? null : { 'notPdf': { value: control.value }};
    };
  }
}

